import React, { useState, useContext } from "react";
import axios from "axios";
import UserService from "services/UserService";
import { withStyles } from "@mui/styles";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import MuiDialogTitle from "@mui/material/DialogTitle";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import EditGroupDialog from "./Group/EditGroupDialog";
import MoveGroupDialog from "./Group/MoveGroupDialog";
import AddGroupDialog from "./Group/AddGroupDialog";
import DelGroupDialog from "./Group/DelGroupDialog";
import styled from "styled-components";
import MenuIcon from "@mui/icons-material/Menu";
import { Menu, MenuItem } from "@mui/material";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { getArchitectureExport } from "services/ConfigServices";

const HeaderDiv = styled.div`
font-size: 15px;
color: #FFFFFF;
font-family: "Source Sans Pro",sans-serif;
background-color: #605f70;
margin-top: 15px;
margin-left: 15px;
margin-right: 15px;
border-bottom: 1px solid #e0e0e0;
padding-left: 15px;
padding-top: 12px;
height: 48px;
border-radius: 4px 4px 0 0;
font-weight: 600;
display: flex;
    justify-content: space-between;
`;

const HeaderTitle = styled.div`

`;

const menuButtonStyle = {
  float: "right",
  position: "relative",
  marginRight: "0",
  paddingTop: "0",
  paddingBottom: "12px",
  paddingRight: "2px",
  fontFamily: '"Source Sans Pro",sans-serif',
  color: "#ffffff",
};


const styless = (theme) => ({
  root: {
    margin: 0,
    padding: '16px',
  },
  closeButton: {
    position: "absolute",
    right: '8px',
    top: '8px',
    color: '#9e9e9e',
  },
  button: {
    backgroundColor: "",
    bordertopleftradius: 0,
    borderbottomleftradius: 0,
    bordertoprightradius: "5px",
    borderbottomrightradius: "5px",
    height: "34px",
    width: "32px",
    textalign: "center",
    display: "flex",
    alignitems: "center",
    justifycontent: "center",
    "&:hover": {
      cursor: "pointer",
    },
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
});

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: '16px',
    marginLeft: "1rem",
  },
  closeButton: {
    position: "absolute",
    right: '8px',
    top: '8px',
    color: '#9e9e9e',
  },
  button: {
    backgroundColor: "",
    bordertopleftradius: 0,
    borderbottomleftradius: 0,
    bordertoprightradius: "5px",
    borderbottomrightradius: "5px",
    height: "34px",
    width: "32px",
    textalign: "center",
    display: "flex",
    alignitems: "center",
    justifycontent: "center",
    "&:hover": {
      cursor: "pointer",
    },
  },
});

const DialogTitle = withStyles(styless)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);


const getType = (type, subtype) => {
  let typeStr = "";
  if (type == 0) {
    if (subtype == 0)
      typeStr = "Commune";
    else if (subtype == 1)
      typeStr = "EPCI";
    else if (subtype == 2)
      typeStr = "Groupe";
  }
  else if (type == 1)
    typeStr = "Site";
  else if (type == 2) {
    if (subtype == 0)
      typeStr = "Bâtiment";
    else if (subtype == 1)
      typeStr = "Equipement urbain";
  }
  else if (type == 3)
    typeStr = "Zone";
  else if (type == 4)
    typeStr = "Compte client";
  else
    typeStr = "";
  return typeStr;
};



export default function TabHeader(props) {
  const permis = JSON.parse(localStorage.getItem('permission')) || [];
  const appContext = useContext(AdvancedSearchContext);
  const currentusertype = localStorage.getItem('userType');
  const { setTreemustrefresh, setSelectedNodesInfo, setGroupchanged, chartIdGroup } = appContext;
  const [openEdit, setOpenEdit] = React.useState(null);
  const [openMove, setOpenMove] = React.useState(null);
  const [openAdd, setOpenAdd] = React.useState(null);
  const [openDel, setOpenDel] = React.useState(null);
  const [openMenu, setOpenMenu] = React.useState(null);
  const handleClick = (event) => {
    setOpenMenu(event.currentTarget);
  };

  const handleClose = () => {
    setOpenMenu(null);
  };

  const handleClickOpenEdit = () => {
    setOpenEdit(true);
    setOpenMenu(null);
  };
  const handleEditClose = () => {
    setOpenEdit(false);
  };
  const handleClickOpenMove = () => {
    setOpenMove(true);
    setOpenMenu(null);
  };
  const handleMoveClose = () => {
    setOpenMove(false);
  };
  const handleClickOpenAdd = () => {
    setOpenAdd(true);
    setOpenMenu(null);
  };
  const handleAddClose = () => {
    setOpenAdd(false);
  };
  const handleClickOpenDel = () => {
    setOpenDel(true);
    setOpenMenu(null);
  };
  const handleDelClose = () => {
    setOpenDel(false);
  };
  const handleClickId = () => {
    setOpenMenu(null);
    alert("id : '" + chartIdGroup + "', importkey : '" + props.importkey + "'");
  };

  const handleClickDownloadArchi = () => {
    axios
      .get(
        getArchitectureExport(chartIdGroup),
        {
          responseType: "blob",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", response.headers.avobfilename); //or any other extension
        document.body.appendChild(link);
        link.click();
        setOpenMenu(null);
      });
  }

  const handleSubmitSuccess = () => {
    setTreemustrefresh(true);
  }

  const handleAddSuccess = (newidgroup, newgroupname) => {
    setSelectedNodesInfo(newgroupname);
    setGroupchanged(newidgroup);
    setTreemustrefresh(true);
  };

  const handleDelSuccess = (parentid) => {
    setSelectedNodesInfo("");
    setGroupchanged(parentid);
    setTreemustrefresh(true);
  };

  const handleExport = () => {

  };

  return (
    <HeaderDiv>
      <HeaderTitle>
        {props.entiteName ? props.entiteName + " (" + (getType(props.type, props.subtype)) + ")" : ""}
      </HeaderTitle>
      {
        permis.includes("realestate_create") ?
          <>
            <Button
              aria-controls="chart-menu"
              aria-haspopup="true"
              onClick={handleClick}
              justicon={"true"}
              style={menuButtonStyle}
            >
              <MenuIcon />
            </Button>
            <Menu
              id="chart-menu"
              className={"chart-menu"}
              anchorEl={openMenu}
              keepMounted
              aria-haspopup={'menu'}
              open={Boolean(openMenu)}
              onClose={handleClose}
            >
              <MenuItem onClick={handleClickOpenEdit} key={`handleEdit`}>
                Editer le groupe
              </MenuItem>
              {
                props.type !== 4 &&
                <MenuItem onClick={handleClickOpenMove} key={`handleMove`}>
                  Déplacer le groupe
                </MenuItem>
              }
              <MenuItem onClick={handleClickOpenAdd} key={`handleAdd`}>
                Ajouter un groupe
              </MenuItem>
              <MenuItem onClick={handleClickOpenDel} key={`handleDel`}>
                Supprimer le groupe
              </MenuItem>
              {currentusertype == 1 ?
                <>
                  <MenuItem onClick={handleClickId} key={`handleId`}>
                    Voir l'identifiant
                  </MenuItem>
                </> : <></>
              }
              <MenuItem onClick={handleClickDownloadArchi} key={`handleArchi`}>
                Télécharger l'architecture
              </MenuItem>
            </Menu>
            <Dialog
              onClose={handleEditClose}
              aria-labelledby="edituser-dialog-title"
              fullWidth="true"
              maxWidth="sm"
              open={openEdit}
            >
              <DialogTitle id="customized-dialog-title" onClose={handleEditClose}>
                Modifier le groupe
              </DialogTitle>
              <DialogContent dividers>
                <EditGroupDialog
                  closeModal={handleEditClose}
                  handleSubmitSuccess={handleSubmitSuccess}
                  name={props.entiteName}
                />
              </DialogContent>
              <DialogActions></DialogActions>
            </Dialog>
            <Dialog
              onClose={handleMoveClose}
              aria-labelledby="edituser-dialog-title"
              fullWidth="true"
              maxWidth="sm"
              open={openMove}
            >
              <DialogTitle id="customized-dialog-title" onClose={handleMoveClose}>
                Déplacer le groupe
              </DialogTitle>
              <DialogContent dividers>
                <MoveGroupDialog
                  closeModal={handleMoveClose}
                  handleSubmitSuccess={handleSubmitSuccess}
                  name={props.entiteName}
                />
              </DialogContent>
              <DialogActions></DialogActions>
            </Dialog>
            <Dialog
              onClose={handleAddClose}
              aria-labelledby="edituser-dialog-title"
              fullWidth="true"
              maxWidth="sm"
              open={openAdd}
            >
              <DialogTitle id="customized-dialog-title" onClose={handleAddClose}>
                Ajouter un groupe
              </DialogTitle>
              <DialogContent dividers>
                <AddGroupDialog
                  closeModal={handleAddClose}
                  handleSubmitSuccess={handleAddSuccess}
                />
              </DialogContent>
              <DialogActions></DialogActions>
            </Dialog>
            <Dialog
              onClose={handleDelClose}
              aria-labelledby="edituser-dialog-title"
              fullWidth="true"
              maxWidth="sm"
              open={openDel}
            >
              <DialogTitle id="customized-dialog-title" onClose={handleDelClose}>
                Supprimer le groupe
              </DialogTitle>
              <DialogContent dividers>
                <DelGroupDialog
                  closeModal={handleDelClose}
                  handleSubmitSuccess={handleDelSuccess}
                />
              </DialogContent>
              <DialogActions></DialogActions>
            </Dialog>
          </> : <></>}
    </HeaderDiv>
  );
}
